// @ts-nocheck
import React, { useRef, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DOMPurify from 'dompurify';
import { formats, modules } from '../../../config/constant';
import { useStyles } from '../style';
import AddressFieldPreview from './AddressFieldPreview';

const TextFormFieldPreview = ({
  element,
  answer,
  handleAnswerChange,
  shouldBeReadOnly,
}) => {
  const [text, setText] = useState(answer);
  const initialTextRef = useRef(answer);
  const classes = useStyles();

  const handleQuillChange = (value) => {
    const cleanedValue = DOMPurify.sanitize(value);
    const strippedValue = cleanedValue.replace(/<\/?[^>]+(>|$)/g, '').trim();

    setText(cleanedValue);
    if (strippedValue === '') {
      handleAnswerChange({ target: { value: '' } });
    } else if (cleanedValue !== initialTextRef.current) {
      handleAnswerChange({ target: { value: cleanedValue } });
      initialTextRef.current = cleanedValue;
    }
  };

  const textRenderField = () => {
    switch (element?.name) {
      case 'Long Text':
        return (
          <ReactQuill
            value={text || answer}
            onChange={handleQuillChange}
            modules={modules}
            formats={formats}
            className={classes.editorStyles}
            readOnly={shouldBeReadOnly}
          />
        );
      case 'Address':
        return (
          <AddressFieldPreview
            answer={answer}
            handleAnswerChange={handleAnswerChange}
            shouldBeReadOnly={shouldBeReadOnly}
          />
        );
      default:
        return (
          <TextField
            name="Text"
            key={element?.id}
            value={answer}
            onChange={handleAnswerChange}
            variant="outlined"
            fullWidth
            placeholder="Answer"
            disabled={shouldBeReadOnly}
          />
        );
    }
  };

  return (
    <Grid key={element?.id} m={1}>
      <FieldsInputTitle
        label={element?.label || element?.name}
        isRequired={element?.isRequired}
      />

      <Grid mt={1.5}>{textRenderField()}</Grid>
    </Grid>
  );
};

export default TextFormFieldPreview;
